// Utility to suppress ResizeObserver errors that are common with Stripe Elements
// These errors are harmless and don't affect functionality

export const suppressResizeObserverErrors = () => {
  // Store original console.error
  const originalError = console.error;

  // Override console.error to filter out ResizeObserver and MutationObserver errors
  console.error = (...args: any[]) => {
    // Check if the error is a ResizeObserver or MutationObserver error
    if (
      typeof args[0] === "string" &&
      (args[0].includes(
        "ResizeObserver loop completed with undelivered notifications"
      ) ||
        args[0].includes("ResizeObserver loop limit exceeded") ||
        args[0].includes("ResizeObserver") ||
        args[0].includes("MutationObserver"))
    ) {
      // Suppress this specific error
      return;
    }

    // For all other errors, use the original console.error
    originalError.apply(console, args);
  };

  // Also handle unhandled promise rejections that might be related
  window.addEventListener("unhandledrejection", (event) => {
    if (
      event.reason &&
      typeof event.reason === "string" &&
      (event.reason.includes("ResizeObserver") || 
       event.reason.includes("MutationObserver"))
    ) {
      event.preventDefault();
    }
  });

  // Handle global error events
  window.addEventListener("error", (event) => {
    if (
      event.message &&
      (event.message.includes("ResizeObserver") || 
       event.message.includes("MutationObserver"))
    ) {
      event.preventDefault();
      return false;
    }
  });

  // Override the global error handler
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (
      typeof message === "string" &&
      (message.includes("ResizeObserver") || 
       message.includes("MutationObserver"))
    ) {
      return true; // Prevent default error handling
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };
};

// Call this function early in your app initialization
export default suppressResizeObserverErrors;
